module.exports = __webpack_public_path__ + "img/smart_oehu.f8248ac4.svg";